export const ONE_HUNDRED_PERCENT = 100 as const;
export const DEFAULT_INVESTMENT_AMOUNT = 10_000 as const;
export const STEP_COUNT = 100 as const;
